import React from 'react'
import {LeaseApplication, LeaseUnitDetail} from '../../types/app-types'
import LoaderInline from '../common/LoaderInline'
import {formatAmount, formatDateString} from '../../services/utils'

interface LeaseDetailProps {
  leaseApplication: LeaseApplication | undefined
  leaseUnitDetail: LeaseUnitDetail | undefined
  className?: string
}

function getMonthlyRent(
  leaseApplication: LeaseApplication,
  leaseUnitDetail: LeaseUnitDetail
) {
  if (leaseApplication?.leaseMonthlyRent) {
    return formatAmount(leaseApplication?.leaseMonthlyRent)
  }
  if (leaseUnitDetail?.monthlyRent) {
    return formatAmount(leaseUnitDetail?.monthlyRent)
  }
  return 'TBD'
}

const LeaseDetail = ({
  leaseApplication,
  leaseUnitDetail,
  className = ''
}: LeaseDetailProps) => {
  const isLoading = !leaseApplication || !leaseUnitDetail
  const startDate = leaseApplication?.leaseStartDate
  const endDate = leaseApplication?.leaseEndDate
  const leasePeriod =
    startDate && endDate
      ? `${formatDateString(startDate)} - ${formatDateString(endDate)}`
      : ' - '
  const monthlyRent = getMonthlyRent(leaseApplication, leaseUnitDetail)
  const address =
    leaseUnitDetail?.propertyAddress &&
    leaseUnitDetail?.propertyCity &&
    leaseUnitDetail?.propertyZip
      ? `${leaseUnitDetail?.propertyAddress}, ${leaseUnitDetail?.propertyCity}, ${leaseUnitDetail?.propertyZip}`
      : ' - '

  return (
    <div className={className}>
      {isLoading ? (
        <div className="flex flew-row justify-items-stretch w-full stats shadow p-4">
          <LoaderInline text="Loading lease details..." />
        </div>
      ) : (
        <div className="flex flew-row flex-wrap justify-items-stretch w-full stats shadow">
          <div className="p-4 basis-1/2 md:basis-1/4">
            <div className="text-center">
              {leaseUnitDetail?.propertyName || ' - '}
            </div>
            <div className="text-center text-xs leading-none text-gray-400">
              {address}
            </div>
          </div>
          <div className="p-4 basis-1/2 md:basis-1/4">
            <div className="text-center">
              Unit {leaseUnitDetail?.unitName || ' - '}
            </div>
            <div className="text-center text-xs leading-none text-gray-400">
              {leaseUnitDetail?.unitDescription || ' - '}
            </div>
          </div>
          <div className="p-4 basis-1/2 md:basis-1/4">
            <div className="text-center">{leasePeriod}</div>
            <div className="text-center text-xs leading-none text-gray-400">
              Lease Period
            </div>
          </div>
          <div className="p-4 basis-1/2 md:basis-1/4">
            <div className="text-center">{monthlyRent}</div>
            <div className="text-center text-xs leading-none text-gray-400">
              Monthly Rent
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default LeaseDetail
